"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getDefaultSelectedFilters = function getDefaultSelectedFilters(_ref) {
  var featureConfig = _ref.featureConfig;
  var _featureConfig$sport = featureConfig.sport,
      sport = _featureConfig$sport === void 0 ? {} : _featureConfig$sport,
      _featureConfig$calcul = featureConfig.calculationMethod,
      calculationMethod = _featureConfig$calcul === void 0 ? {} : _featureConfig$calcul,
      _featureConfig$groupi = featureConfig.grouping,
      grouping = _featureConfig$groupi === void 0 ? {} : _featureConfig$groupi,
      _featureConfig$sort = featureConfig.sort,
      sort = _featureConfig$sort === void 0 ? {} : _featureConfig$sort,
      _featureConfig$period = featureConfig.period,
      period = _featureConfig$period === void 0 ? {} : _featureConfig$period,
      _featureConfig$displa = featureConfig.display,
      display = _featureConfig$displa === void 0 ? {} : _featureConfig$displa;
  var config = {
    sport: sport["default"] || 'All',
    grouping: grouping["default"],
    period: period["default"],
    sort: sort["default"],
    calculationMethod: calculationMethod["default"],
    display: display
  };
  return config;
};

var _default = getDefaultSelectedFilters;
exports["default"] = _default;
//# sourceMappingURL=getDefaultSelectedFilters.js.map